var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.016,
    cy: 11.713,
    r: 0.584
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.362,5.949c0.301,-0.875 1.26,-1.331 2.129,-1.025c0.001,0 0.001,0.001 0.002,0.001c0.669,0.234 1.114,0.865 1.114,1.579c0,0.423 -0.28,0.746 -0.585,1c-0.562,0.469 -1.266,0.703 -1.266,0.703c-0.292,0.098 -0.45,0.414 -0.353,0.706c0.098,0.292 0.414,0.451 0.706,0.353c0,0 0.904,-0.302 1.628,-0.904c0.553,-0.461 0.987,-1.09 0.987,-1.858c-0,-1.191 -0.746,-2.242 -1.862,-2.633c-1.452,-0.511 -3.053,0.253 -3.555,1.715c-0.101,0.291 0.054,0.609 0.346,0.709c0.291,0.1 0.609,-0.055 0.709,-0.346Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,-0c-2.122,-0 -4.157,0.843 -5.657,2.343c-1.5,1.5 -2.343,3.535 -2.343,5.657c-0,2.122 0.843,4.157 2.343,5.657c0,-0 0,-0 0,-0c1.5,1.5 3.535,2.343 5.657,2.343c2.122,-0 4.157,-0.843 5.657,-2.343c-0,-0 -0,-0 -0,-0c1.5,-1.5 2.343,-3.535 2.343,-5.657c-0,-2.122 -0.843,-4.157 -2.343,-5.657c-0,0 -0,0 -0,0c-1.5,-1.5 -3.535,-2.343 -5.657,-2.343Zm-0,1.116c1.826,0 3.577,0.726 4.868,2.016c1.29,1.291 2.016,3.042 2.016,4.868c-0,1.826 -0.726,3.577 -2.016,4.868c-1.291,1.29 -3.042,2.016 -4.868,2.016c-1.826,-0 -3.577,-0.726 -4.868,-2.016c-1.29,-1.291 -2.016,-3.042 -2.016,-4.868c0,-1.826 0.726,-3.577 2.016,-4.867c1.291,-1.291 3.042,-2.017 4.868,-2.017Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.bfd2a20df0519d1cf85ae682635dc307.svg";
export { ForwardRef as ReactComponent };